import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "./Header";

import branding from '../assets/missions-branding.webp'
import production from '../assets/missions-production.webp'
import uiux from '../assets/missions-ui-ux.webp'
import seo from '../assets/missioins-seo.webp'
import "../Mission.css";
import PageTransition from "../PageTransition";
import { Helmet } from "react-helmet-async";



const SERVICES = [
  { title: "Branding", image: branding, link: "/branding" },
  { title: "SEO & GEO", image: seo, link: "/seo-geo" },
  { title: "Production & Post-Production", image: production, link: "/production-post-production" },
  { title: "UI/UX Design", image: uiux, link: "/ui-ux" },
];

export default function ContentMissions() {
  const navigate = useNavigate();
const scrollRef = useRef(null);
const [activeIndex, setActiveIndex] = useState(0);

 useEffect(() => {
  const slides = document.querySelectorAll(".missions-slide");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const idx = Number(entry.target.dataset.index);
          setActiveIndex(idx);
          entry.target.classList.add("is-active");
        } else {
          entry.target.classList.remove("is-active");
        }
      });
    },
    { threshold: 0.6 }
  );

  slides.forEach((slide) => observer.observe(slide));
  return () => observer.disconnect();
}, []);

  return (
    <>

      <Helmet>
        <title>UX Strategy & Web Design Approach | 2 Light Years Missions</title>

        <meta 
          name="description" 
          content="Discover how 2 Light Years approaches UX design, web performance, and conversion optimization through strategic thinking and mission-driven digital experiences." 
        />

        <meta name="robots" content="index, follow" />

        <link rel="canonical" href="https://www.2lightyears.com/missions" />

        {/* Open Graph */}
        <meta property="og:title" content="UX Strategy & Web Design Mission | 2 Light Years" />
        <meta property="og:description" content="Learn our approach to UX, performance, and conversion optimization." />
        <meta property="og:url" content="https://www.2lightyears.com/missions" />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="UX Strategy & Web Design Mission | 2 Light Years" />
        <meta name="twitter:description" content="Our mission-driven approach to UX and high-performance websites." />
      </Helmet>

      <Header visible mode="normal" />
                 <PageTransition>

      <section className="missions-root">
        <div className="missions-scroll" ref={scrollRef}>

         {SERVICES.map((service, i) => (
          <div
            className="missions-slide"
            key={i}
            data-index={i}
            onClick={() => navigate(service.link)}
             >

              <div
                className="missions-bg"
                style={{ backgroundImage: `url(${service.image})` }}
              />

              <div className="missions-overlay" />

              <h1>{service.title}</h1>
            </div>
          ))}
        </div>
        <div className="missions-dots">
  {SERVICES.map((_, i) => (
    <button
      key={i}
      className={`dot ${activeIndex === i ? "active" : ""}`}
      onClick={() => {
        const target = scrollRef.current.children[i];
        target.scrollIntoView({ behavior: "smooth" });
      }}
    />
  ))}
</div>

      </section>
      </PageTransition>
    </>
  );
}
